export class DeliveryAddress {
  constructor(
    public id: number,
    public state: string,
    public street1: string,
    public street2: string | null,
    public addressId: number,
    public city: string,
    public zipCode: string,
    public entryCode: string | null,
    public deliveryInstructions: string | null,
    public addressLabel: string | null,
    public isDefault: boolean,
  ) {}

  toString() {
    return `${this.street1}${this.street2 ? ` ${this.street2}` : ""}, ${this.city}, ${this.state} ${this.zipCode}`
  }

  static fromDynamic(data: { [key: string]: any }): DeliveryAddress {
    return new DeliveryAddress(
      data["user_delivery_address_id"],
      data["state"],
      data["street1"],
      data["street2"] ?? null,
      data["address_id"],
      data["city"],
      data["zip_code"],
      data["preferences"]["entryCode"] ?? "",
      data["preferences"]["deliveryInstructions"] ?? "",
      data["preferences"]["addressLabel"] ?? "",
      data["is_default"],
    )
  }
}
